import { React, useRef, useEffect, useState } from "react";
import { API_BASE_URL } from "../../environment";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import NewTopNavBar from "../NewTopNavBar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { filterDataByUserTags } from "../../utils/commons";
import { FaGreaterThan } from "react-icons/fa";
import HamburgerNavigation from "../HamburgerNavigation";
import InnerHamburgerNavigation from "../InnerHamburgerNavigation";
// import krVideo from "../../Img/My Movie 12.mp4";
// import krVideo from "../../Img/freepik__create-a-highquality-video-featuring-a-mesmerizing__98682 1.mp4";
import krVideo from "../../Img/My Movie 13.mp4";
// import krVideo from "../../Img/freepik__create-a-highquality-video-featuring-a-mesmerizing__62356 1.mp4";

// import IsoImg from "../../Img/Camptra_ISO_Certified.png"
import AdminData from "../../Json/AdminHomeJson.json"
const SearchLandingPageNew = () => {
  console.log("AdminData=", AdminData)
  const [page, setPage] = useState(0);
  const [filterData, setFilterData] = useState([]);
  // const [spnierLoading, setSpnierLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [spiner, setSpiner] = useState(true);
  const [query, setQuery] = useState("");
  const sentinelRef = useRef(null);
  const [postTitles, setPostTitles] = useState([]);
  const navigate = useNavigate();
  const [collaps, setCollaps] = useState(true);
  const [isDisplay, setIsDisplay] = useState(true);
  let bearerToken = localStorage.getItem("jwt_token");
  const [inputFocused, setInputFocused] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false)
  const suggestionRef = useRef(null);
  const handleInputChange = (e) => {
    // console.log(process.env.REACT_APP_API_ENDPOINT);
    const inputQuery = e.target.value;

    setQuery(inputQuery);
  };

  // search article function start //

  const handleSearch = (e) => {
    e.preventDefault(); // Prevent form submission
    if (query == "") {
      toast.error("Enter text to perform a search.");
      return;
    } else if (query.length == 1) {
      toast.error("Please provide additional text to refine your search.");
      return;
    }
    localStorage.removeItem("subcategoryId");
    localStorage.removeItem("catagoryId");
    navigate(`/results`);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (query.trim() !== "") {
        fetchPostTitles();
      } else {
        setPostTitles([]);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  // search article function end //

  // fetch article function start //

  const fetchPostTitles = () => {
    if (query) {
      let request = {
        method: "GET",
        url: `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&per_page=100`,
      };
      const startTime = new Date();

      fetch(
        `${API_BASE_URL}/wp-json/wp/v2/posts?search=${query}&per_page=100`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          const endTime = new Date();
          // logApiRequest(request, response, startTime, endTime);
          return response.json(); // Return the parsed JSON to the next .then()
        })
        .then((data) => {
          // Assuming the response contains post titles as an array
          console.log("data71=", data);
          setIsDisplay(true);
          data = filterDataByUserTags(data);
          const normalPost = [];
          const filterPosts = data.filter((data) => {
            console.log("50=", data.title.rendered);
            if (
              data.title.rendered.toLowerCase().includes(query.toLowerCase())
            ) {
              return data;
            } else {
              normalPost.push(data);
            }
          });
          filterPosts.push(...normalPost);
          setPostTitles(filterPosts);
          console.log(data);
        })
        .catch((error) => {
          console.error(error);
          localStorage.removeItem("jwt_token");
          localStorage.removeItem("tags");
          // logApiRequest(request, error.response || { status: error.message });
          navigate("/");
        });
    } else {
      // Clear post titles if the query is empty
      setPostTitles([]);
    }
  };

  // fetch article function end //

  // got to article function start//
  const gotToArticlePage = (postId) => {
    // localStorage.setItem("postId", postId)
    navigate(`/single-article?id=${postId}`);
  };

  // go to article function end //

  // go to sub category page start //

  const catagoryHandle = (catId, catName) => {
    // alert(catId)
    if (userRolles == 'administrator') {
      toast.error('You are not authorized to view the articles, subcategories, or search results.');
      return
    }
    localStorage.setItem("catagoryId", catId);
    localStorage.setItem("categoryName", catName);
    // navigate('/category-posts')
    navigate("/subcategory");
  };

  // go to sub category page end //

  //

  let categoryLength = [];
  // fetch categories start //
  const fetchCategories = (page) => {
    setLoading(true);
    // setSpiner(true)
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom-category/v1/get-parent-categories?page=${page}`
      )
      .then((response) => {
        //
        setSpiner(false);
        axios
          .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`)
          .then((res) => {
            const whitlistUrl = res.data.filter((res) => {
              if (res.url.includes(window.location.origin)) {
                return res;
              }
            });
            categoryLength = response.data;
            console.log("whitelist url=", response.data);

            const parentCategory = response.data.filter((data) => {
              if (
                data.parent == 0 &&
                whitlistUrl[0].category.includes(data.id) &&
                whitlistUrl[0].toggle_status == true
              ) {
                return data;
              }
            });

            // const parentCategory = response.data.filter((data) => {
            //   // console.log('line279=', whitlistUrl[0].category.includes(data.id))
            //   if (data.parent == 0) {
            //     return data;
            //   }
            // });

            console.log("283=", parentCategory);
            setLoading(false);

            setFilterData((prevPosts) => [...prevPosts, ...parentCategory]);
            // setCategoriesWithCount(response.data);
            // setCategoriesWithCount(parentCategory);
            // setSpnierLoading(spnierLoading ? false : true)
            // setSpnierLoading(false);
            // console.log("spinerloading=", spnierLoading);
            // alert('alert2')
          })
          .catch((err) => {
            console.log(err);
            // alert('alert3')
          });
        //
        // setFilterData((prevPosts) => [...prevPosts, ...res.data]);
        // setSpnierLoading(false);
        setLoading(false);
        // setSpiner(false)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // fetch categories end //
  // In finite scroll start //
  useEffect(() => {
    console.log("line35", page);
    if (page != 0) {
      fetchCategories(page);
    }
  }, [page]);
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      });
    },
    { threshold: 1 }
  );
  //
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        // setIsVisible(true);

        if (categoryLength.length != 0) {
          setPage((prevPage) => prevPage + 1);
          setLoading(true);
        }
      } else {
        // setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page]);

  const userRolles = localStorage.getItem("roles");

  //
  useEffect(() => {
    if (userRolles == 'administrator') {
      setIsDisabled(true)
    }

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  // Infinite Scroll End
  const mainDivClick = () => {
    setIsDisplay(false);
    // document.getElementById("suggestionId").style.display = "none";
  };
  localStorage.setItem("searchQuery", query);

  // store user name start
  // function for checking from where we access platform or widget start //
  const storeUserInfo = () => {
    const userData = {
      username: localStorage.getItem("userEmail"),
      access_from: "Platform",
    };
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/store-oracle-user-data`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => { })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    storeUserInfo();
  }, []);
  // function for checking from where we access platform or widget end //

  //store user name end
  // alert(spiner)
  // if (spiner) {
  //   return <div className=" d-flex justify-content-center pt-5">
  //     <Spinner />
  //   </div>; // Show a loader while waiting for the API response
  // }
  return (
    <>
      {/* {alert(filterData?.length)} */}
      {/* {spiner ? */}
      <div className="">
        <div onClick={mainDivClick}>
          {!spiner ? (
            <div className="landing-page-banner ">
              {/* <NewTopNavBar /> */}
              {/* Navbar Start  */}
              <div className="top-nav">
                {/* <TopNavBar /> */}
                <NewTopNavBar />
              </div>
              <InnerHamburgerNavigation />
              <HamburgerNavigation />
              {/* Navbar End */}
              {/* Banner and search div start */}
              <div className="w-100 banner-div" style={{ top: "100px" }}>
                {/* <div className='p-4'>
              <button style={{ border: 'none' }} onClick={CollapseSidbarBtn} className="  order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button>
            </div> */}
                <div className="w-100 pt-5 fw-bold">
                  <div className="search-back w-100 pt-5">
                    {/* <h2 className='fw-bold'>Knowledge Base</h2> */}
                    <p style={{ fontSize: "28px" }}>
                      Great service changes everything.
                      {/* Search for Articles */}
                    </p>
                  </div>
                </div>
                <div className="search-back w-100">
                  <form
                    role="search"
                    method="get"
                    className="search-form mb-5"
                    onSubmit={handleSearch}

                  >
                    <label
                      style={{
                        // flex: "1", background: "#ffffff59"
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: inputFocused ? "white" : "",
                        // transition: "background-color 0.1s",
                        // border: '1px solid black'
                      }}
                      onMouseDown={() => setButtonClicked(true)}
                      onMouseUp={() => setButtonClicked(false)}
                    >
                      {/* <span
                      style={{
                        position: "absolute",
                        top: "69.8%",
                        left: "27%", // Icon's position
                        transform: "translateY(-50%)",
                        pointerEvents: "none", // Prevent interaction with the icon
                        // color: "gray", // Icon color
                        fontSize: "36px", // Icon size
                        // zIndex: 999999
                      }}
                    > */}
                      <span className="ps-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
                          />
                        </svg>
                      </span>
                      {/* </span> */}
                      <input


                        type="text"
                        className="search-field-new "
                        placeholder="Search for articles.."
                        value={query}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: inputFocused
                            ? "white"
                            : "transparent",
                          // transition: "background-color 0.3s",
                        }}
                        onFocus={() => setInputFocused(true)}
                        onBlur={() => setInputFocused(false)}
                        disabled={isDisabled}

                      />
                    </label>
                    <button
                      type="submit"
                      className="search-submit d-none"
                      style={
                        {
                          // backgroundColor: inputFocused ? "white" : "transparent",
                          // transition: "background-color 0.3s",
                          // border: "none",
                        }
                      }
                    // onMouseDown={() => setButtonClicked(true)}
                    // onMouseUp={() => setButtonClicked(false)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14z"
                        />
                      </svg>
                    </button>

                    {/* <SearchResults results={suggestions} /> */}
                  </form>
                  {/* <div>
                <img src={AiImg} alt="" />
              </div> */}
                </div>
                {console.log("suggestion-list", postTitles)}
                {query.trim() !== "" && (
                  <ul
                    id={isDisplay ? "suggestionBlock" : "suggestionNone"}
                    className={collaps ? "suggestion-list2" : "suggestion-list"}
                  >
                    {postTitles
                      ? postTitles.map((title, index) => (
                        <div
                          className="p-0 m-0 suggestion-link"
                          onClick={() => gotToArticlePage(title.id)}
                        >
                          <li key={index} className="m-0 suggestion">
                            {title.title.rendered}
                          </li>
                        </div>
                      ))
                      : ""}
                  </ul>
                )}
              </div>
              {/* Banner and search div end */}
            </div>
          ) : (
            ""
          )}
          <div
            className="overflow-auto pt-5"
          // style={{ height: '30vh' }}
          >
            {/* category box container start */}
            <div className="container card-box-main-div">
              <div className="row g-0">
                {/* {alert(filterData?.length)} */}
                {filterData?.length && !isDisabled > 0 ? (
                  filterData?.map((val) => {
                    // console.log("val=", val)
                    return (
                      // <div className=" col-12 col-md-4 col-sm-6 col-xl-3  mb-3 pe-2">

                      // </div>
                      <div
                        disabled={isDisabled}

                        //   style={{ height: "70px" }}
                        onClick={() => catagoryHandle(val.id, val.name)}
                        className="col-sm-6 col-md-6 col-lg-4"

                      // style={{
                      //   pointerEvents: isDisabled ? 'none' : 'auto',
                      //   opacity: isDisabled ? 0.5 : 1, // Optional: Visually indicate disabled state
                      // }}
                      >
                        <div
                          className="d-flex  border m-2 categoryBoxMainDiv">
                          <img
                            className="categoryImgBox"
                            height={60}
                            width={60}
                            src={val.image}
                            alt=""
                          />
                          {/* <div className='categoryImgBox '>

                      </div> */}
                          <div>
                            <div className="categoryNameDiv">
                              <p className="mb-0 fw-bold">
                                {val.name.length > 20
                                  ? `${val.name.slice(0, 20)}...`
                                  : val.name}
                              </p>
                            </div>
                            <div className="d-flex ">
                              <p className="mb-0">
                                {val.unique_authors_count}{" "}
                                {val.unique_authors_count <= 1
                                  ? "Author"
                                  : "Authors"}
                              </p>
                              <p className="ps-4 mb-0">
                                {val.post_count}{" "}
                                {val.post_count <= 1 ? "Article" : "Articles"}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : isDisabled && filterData?.length ? AdminData.map((data, index) => {
                  return (
                    <div
                      className="col-sm-6 col-md-6 col-lg-4" onClick={() => navigate(data.slug)}>
                      <div className="border m-2 categoryBoxMainDiv">
                        <div data-toggle="tooltip"
                          data-placement="bottom"
                          title={data.menu} className="d-flex justify-content-center  ">
                          <img src={data.img_url} alt="" width={50} />

                        </div>
                        <div className="text-center pt-2">{data.menu}</div>
                      </div>
                    </div>
                  )
                }) : (
                  <div className="d-flex justify-content-center ">
                    {/* <div>Data not found</div> */}
                    {/* {console.log("520")} */}
                    <Spinner />
                  </div>
                )}
              </div>
            </div>
            {/* category box container end */}
            <div ref={sentinelRef} />
            {/* {alert(loading && filterData?.length > 0)} */}
            {loading && !isDisabled && filterData?.length > 0 ? (
              <div className="d-flex justify-content-center mb-5">
                {" "}
                <Spinner />{" "}
              </div>
            ) : (
              ""
            )}
          </div>
          {/* video section start  */}
          {!spiner ? (
            <div className="container">
              <div className="row">
                {/* <div className="col-1"></div> */}
                <div className="col-12">
                  {/*  */}

                  {/*  */}
                  <div className="fin-bg-img-container ">
                    {/* <video controls>
                      <source src={krVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video> */}
                    <div className="my-4">
                      <video
                        className="w-100 "
                        // controls
                        autoPlay
                        loop
                        muted
                        style={{
                          objectFit: "cover",
                          height: "20vh",
                          marginTop: "8px",
                        }}
                      >
                        <source src={krVideo} type="video/mp4" />
                      </video>
                    </div>
                    <section className="fin-bg-img my-2 d-none">
                      <div>
                        <h4>Camptra Service</h4>
                        {/* <p>The first AI agent that delivers human-quality service</p> */}
                        <div>
                          <button className="btn-dark btn"> Learn more</button>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
                {/* <div className="col-1"></div> */}
              </div>
            </div>
          ) : (
            ""
          )}
          {/*  */}
        </div>
        {/* video section end */}
        {/* {!spiner ?
          <div className=" d-flex justify-content-center pt-5">
            <Spinner />
          </div> // Show a loader while waiting for the API response
          : ""} */}
        {/*  */}
        {/* footer  start */}
        {!spiner ? (
          <footer className="bg-dark pt-5 pb-4">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="d-flex camptra-footer-img">
                    <div>
                      <img
                        src="https://camptratech.com/wp-content/uploads/2023/07/Camptra_ISO_Certified-removebg-preview-300x300.png"
                        alt=""
                      />
                    </div>

                    <div>
                      <img
                        src="https://camptratech.com/wp-content/uploads/2023/07/SOC_2-removebg-preview.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 text-white footer-text">
                  <div>
                    <p className="fs-5">Camptra Technologies</p>
                    <div className="footer-menu-section pt-2">
                      <p>
                        {/* <FaGreaterThan width={5} /> */}

                        <a href="https://camptratech.com/" target="_blank">
                          <span className="pe-2">
                            <i
                              aria-hidden="true"
                              class="fas fa-angle-right"
                            ></i>
                          </span>{" "}
                          Home
                        </a>
                      </p>
                      <p>
                        <a
                          href="https://camptratech.com/services/"
                          target="_blank"
                        >
                          <span className="pe-2">
                            <i
                              aria-hidden="true"
                              class="fas fa-angle-right"
                            ></i>
                          </span>{" "}
                          <span>Services</span>{" "}
                        </a>
                      </p>
                      <p>
                        <a
                          href="https://camptratech.com/solutions/"
                          target="_blank"
                        >
                          <span className="pe-2">
                            <i
                              aria-hidden="true"
                              class="fas fa-angle-right"
                            ></i>
                          </span>{" "}
                          <span>Solutions</span>{" "}
                        </a>
                      </p>
                      <p>
                        <a
                          href="https://camptratech.com/about-us/"
                          target="_blank"
                        >
                          <span className="pe-2">
                            <i
                              aria-hidden="true"
                              class="fas fa-angle-right"
                            ></i>
                          </span>{" "}
                          Company{" "}
                        </a>
                      </p>
                      <p>
                        <a
                          href="https://camptratech.com/success-stories/"
                          target="_blank"
                        >
                          <span className="pe-2">
                            <i
                              aria-hidden="true"
                              class="fas fa-angle-right"
                            ></i>
                          </span>
                          Resources
                        </a>
                      </p>
                      <p>
                        <a
                          href="https://camptratech.com/careers/"
                          target="_blank"
                        >
                          {" "}
                          <span className="pe-2">
                            <i
                              aria-hidden="true"
                              class="fas fa-angle-right"
                            ></i>
                          </span>
                          Careers
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-4 col-sm-12 text-white footer-text">
                  <div>
                    <div className="d-flex">
                      <div>
                        <span className="phone-logo-bg-div ">
                          <i
                            aria-hidden="true"
                            className="fas fa-phone-alt"
                          ></i>
                        </span>
                      </div>
                      <div className="ps-4 pt-1">
                        <h4>
                          <span>GET IN TOUCH</span>{" "}
                          <span style={{ color: "#9dd400" }}>WITH US</span>
                        </h4>
                      </div>
                    </div>
                    <div className="pt-3">
                      We started our journey with a team of seasoned software
                      engineers and technology specialists. Today, we use our
                      expertise in implementation and training to help you
                      maximize the returns on your Cloud investment.
                    </div>
                    <div className=" location-block">
                      <i aria-hidden="true" class="fas fa-map-marker-alt"></i>
                      <span className="ps-2">
                        1309 W. 15th Street, Suite 240, Plano, TX 75075 USA
                      </span>
                    </div>
                    <div className=" location-block">
                      <a
                        className="contact-block "
                        href="tel:%20+1%20(877)%20723-5474"
                      >
                        <span class="elementor-icon-list-icon mbolile-icon-rotation">
                          <i
                            aria-hidden="true"
                            className="fas fa-phone-alt"
                          ></i>{" "}
                        </span>
                        <span class="elementor-icon-list-text ps-2">
                          {" "}
                          +1 (877) 723-5474
                        </span>
                      </a>
                    </div>
                    <div className=" pt-3">
                      <a
                        className="contact-block "
                        href="mailto:%20info@camptratech.com"
                      >
                        <span class="elementor-icon-list-icon">
                          <i aria-hidden="true" class="far fa-envelope"></i>{" "}
                        </span>
                        <span class="elementor-icon-list-text ps-2">
                          {" "}
                          info@camptratech.com
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        ) : (
          ""
        )}
        {/* footer end*/}
      </div>
      {/* : <div className=" d-flex justify-content-center pt-5">
          <Spinner />
        </div>
      } */}
    </>
  );
};

export default SearchLandingPageNew;
